import React from "react"
import HeadTitle from "../../common/HeadTitle/HeadTitle"
import ContactFrom from "./ContactForm"

const Contact = () => {
  return (
    <>
      <HeadTitle />
      <ContactFrom />
    </>
  )
}

export default Contact